import * as React from 'react';
import { ComponentType } from 'react';
import {
  withJsonFormsControlProps,
  withJsonFormsAllOfProps,
  withJsonFormsAnyOfProps,
  withJsonFormsArrayControlProps,
  withJsonFormsOneOfProps,
  withJsonFormsDetailProps,
  withJsonFormsArrayLayoutProps,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { ErrorBoundaryWrapper } from '@web-config-app/core-react-ui';
import {
  CreateRendererProps,
  EntityFormRendererType,
} from '../types/renderers';

const rendererTypeWrapperMap: Record<
  EntityFormRendererType,
  (...args: any[]) => any
> = {
  primitive: withJsonFormsControlProps,
  object: withJsonFormsDetailProps,
  array: withJsonFormsArrayControlProps,
  anyOf: withJsonFormsAnyOfProps,
  allOf: withJsonFormsAllOfProps,
  oneOf: withJsonFormsOneOfProps,
  objectLayout: withJsonFormsLayoutProps,
  arrayLayout: withJsonFormsArrayLayoutProps,
};

export function createEntityFormRenderer<T>(
  renderer: ComponentType<CreateRendererProps<T>>,
  rendererType: EntityFormRendererType,
  memoize: boolean,
  omitPropsWrapperFn: boolean,
): ComponentType<CreateRendererProps<T>> {
  const WrappedRenderer = omitPropsWrapperFn
    ? renderer
    : rendererTypeWrapperMap[rendererType](renderer, memoize);

  const WrappedWithErrorBoundary: ComponentType<CreateRendererProps<T>> = (
    props: CreateRendererProps<T>,
  ) => (
    <ErrorBoundaryWrapper>
      <WrappedRenderer {...props} />
    </ErrorBoundaryWrapper>
  );

  return WrappedWithErrorBoundary;
}
